import React, { useState } from 'react'
import tw from 'tailwind-styled-components';
import { FaArrowLeft, FaShoppingCart, FaSearch, FaTruck, FaUndo, FaUser, FaChevronRight, FaPhoneAlt } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { Set_Cart_Modal_Open } from '../Redux/actions';
import { useSelector, useDispatch } from 'react-redux';
import Cart from '../components/Cart';
import { IoChatbubbleEllipsesSharp } from 'react-icons/io5';
import EmailLoginModal from '../components/EmailLoginModal';
import LoginModal from '../Pages/User/Login';
import SignupModal from '../Pages/User/Register';

const Help = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const user = useSelector((state) => state.UserReducer.user);
    const isCartModalOpen = useSelector((state) => state.CartReducer.isCartModalOpen);
    const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
    const [isOTPLoginModalOpen, setIsOTPLoginModalOpen] = useState(false);
    const [isSignupModalOpen, setIsSignupModalOpen] = useState(false);

    const handleBack = () => {            // Navigate back to home
        navigate('/');
    };

    const handleOpenCartModal = () => {
        if (user) {
            dispatch(Set_Cart_Modal_Open(true));
        } else {
            // Open email login modal if user is not logged in
            setIsLoginModalOpen(true);
        }
    };

    const handleCloseCartModal = () => {
        dispatch(Set_Cart_Modal_Open(false));
    };

    return (
        <PageContainer>
            <TopNavbar>
                <BackButton onClick={handleBack}>
                    <FaArrowLeft className="w-5 h-5" />
                </BackButton>
                <PageTitle>Help & Support</PageTitle>

                <SearchBar>
                    <FaSearch className="absolute left-3 w-5 h-5 text-kuality-blue" />
                    <SearchInput type="text" placeholder="Search for answers..." />
                </SearchBar>

                <CartButton onClick={handleOpenCartModal}>
                    <FaShoppingCart className="w-6 h-6" />
                </CartButton>
            </TopNavbar>

            <MobileSearchBar>
                <MobileSearchWrapper>
                    <FaSearch className="absolute left-3 w-5 h-5 text-kuality-blue" />
                    <SearchInput
                        type="text"
                        placeholder='Search for answers...'
                    />
                </MobileSearchWrapper>
            </MobileSearchBar>

            <QuickActions>
                <SectionTitle>Quick Actions</SectionTitle>
                <ActionButtons>
                    <TrackOrder>
                        <FaTruck className="w-5 h-5 text-kuality-blue" />
                        <span>Track My Order</span>
                    </TrackOrder>
                    <ReturnRefunds onClick={() => navigate('/returns&refunds')}>
                        <FaUndo className="w-5 h-5 text-kuality-blue" />
                        <span>Returns & Refunds</span>
                    </ReturnRefunds>
                    <ManageAccount>
                        <FaUser className="w-5 h-5 text-kuality-blue" />
                        <span>Manage Account</span>
                    </ManageAccount>
                </ActionButtons>
            </QuickActions>

            <FAQs>
                <SectionTitle>Frequently Asked Questions</SectionTitle>
                <FAQItem>
                    <span>How to track my order?</span>
                    <FaChevronRight className="w-4 h-4" />
                </FAQItem>
                <FAQItem>
                    <span>What is the return policy?</span>
                    <FaChevronRight className="w-4 h-4" />
                </FAQItem>
                <FAQItem>
                    <span>How to change my account details?</span>
                    <FaChevronRight className="w-4 h-4" />
                </FAQItem>
                <FAQItem>
                    <span>How to contact customer support?</span>
                    <FaChevronRight className="w-4 h-4" />
                </FAQItem>
            </FAQs>

            <ContactUs>
                <SectionTitle>Contact Us</SectionTitle>
                <ActionButtons>
                    <LiveChat>
                        <IoChatbubbleEllipsesSharp className="w-5 h-5 font-bold text-kuality-blue" />
                        <span>Live Chat</span>
                    </LiveChat>
                    <CallSupport>
                        <FaPhoneAlt className="w-5 h-5 text-kuality-blue" />
                        <span>Call Support</span>
                    </CallSupport>
                </ActionButtons>
            </ContactUs>

            {/* Modals */}
            <EmailLoginModal
                isOpen={isLoginModalOpen}
                onClose={() => setIsLoginModalOpen(false)}
                onSwitchToSignup={() => {
                    setIsLoginModalOpen(false);
                    setIsSignupModalOpen(true);
                }}
                onSwitchToEmailLogin={() => {
                    setIsLoginModalOpen(false);
                    setIsOTPLoginModalOpen(true);
                }}
            />
            <LoginModal
                isOpen={isOTPLoginModalOpen}
                onClose={() => setIsOTPLoginModalOpen(false)}
                onSwitchToSignup={() => {
                    setIsOTPLoginModalOpen(false);
                    setIsSignupModalOpen(true);
                }}
            />
            <SignupModal
                isOpen={isSignupModalOpen}
                onClose={() => setIsSignupModalOpen(false)}
                onSwitchToLogin={() => {
                    setIsSignupModalOpen(false);
                    setIsLoginModalOpen(true);
                }}
            />
            <Cart isOpen={isCartModalOpen} onClose={handleCloseCartModal} />

        </PageContainer>
    )
}


// Styled Components
const PageContainer = tw.div`
  min-h-screen w-full bg-white
`;

const TopNavbar = tw.div`
  flex justify-between items-center p-3 md:p-2 bg-white border-b border-gray-200 sticky top-0 z-10
`;

const BackButton = tw.button`
  text-gray-600 hover:text-gray-900 p-2 rounded-lg hover:bg-gray-100 transition-colors
`;

const PageTitle = tw.h1`
  text-lg font-semibold text-gray-800 tracking-wider md:text-xl
`;

const CartButton = tw.button`
  p-1 text-gray-600 hover:text-gray-800 transition-colors md:p-2
`;

const SearchBar = tw.div`
   relative flex items-center w-full hidden md:flex items-center justify-center flex-1 max-w-3xl mx-2 sm:mx-4
`;

const SearchInput = tw.input`
    w-full px-10 py-2 border-2 border-gray-200 bg-gray-100 text-md focus:outline-none rounded-lg
`;

const MobileSearchBar = tw.div`
    md:hidden px-4 py-2
`;

const MobileSearchWrapper = tw.div`
    relative flex items-center w-full
`;

const QuickActions = tw.div`
 p-4 pt-1  md:mx-20
`;

const SectionTitle = tw.h2`
    text-lg md:text-xl font-semibold text-gray-800 my-2 md:my-3
`;

const ActionButtons = tw.div`
    flex flex-row gap-2 md:px-14 md:py-2
`;

const TrackOrder = tw.button`
    w-full py-3 md:py-7 bg-gray-100 text-gray-800 font-medium rounded-md hover:shadow-md transition-colors flex flex-col items-center justify-center gap-2 md:gap-3
`;
const ReturnRefunds = tw.button`
    w-full py-3 md:py-7 bg-gray-100 text-gray-800 font-medium rounded-md hover:shadow-md transition-colors flex flex-col items-center justify-center gap-2 md:gap-3
`;
const ManageAccount = tw.button`
    w-full py-3 md:py-7 bg-gray-100 text-gray-800 font-medium rounded-md
    hover:shadow-md transition-colors flex flex-col items-center justify-center gap-2 md:gap-3
`;

const FAQs = tw.div`
    p-4 pt-1 md:mx-20
`;

const FAQItem = tw.button`
    w-full flex items-center justify-between border-b border-gray-200 py-4
`;

const ContactUs = tw.div`
    p-4 pt-1 md:mx-20
`;

const LiveChat = tw.button`
    w-full py-3 md:py-5 bg-gray-100 text-gray-800 font-medium rounded-md hover:shadow-md transition-colors flex items-center justify-center gap-2 md:gap-3
`;
const CallSupport = tw.button`
    w-full py-3 md:py-5 bg-gray-100 text-gray-800 font-medium rounded-md hover:shadow-md transition-colors flex items-center justify-center gap-2 md:gap-3
`;

export default Help